<template>
  <sg-focus-group-collection>
    <sg-roving-focus-group-impl v-bind="$attrs">
      <slot />
    </sg-roving-focus-group-impl>
  </sg-focus-group-collection>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SgRovingFocusGroupImpl from './roving-focus-group-impl.vue'
import { SgCollection as SgFocusGroupCollection } from './roving-focus-group'

export default defineComponent({
  name: 'SgRovingFocusGroup',
  components: {
    SgFocusGroupCollection,
    SgRovingFocusGroupImpl,
  },
})
</script>
